module.exports = __webpack_public_path__ + "img/dct-01.prt.6393d495.jpg";